export abstract class BridgeTokenIconHelper {
  static forSymbol(symbol: string): string {
    const icons: Record<string, string> = {
      GAS: require('@/assets/img/gas.svg'),
      NEO: require('@/assets/img/neo.svg'),
      FLM: require('@/assets/img/flamingo-icon.svg'),
      NDMEME: require('@/assets/img/tokens/ndmeme.svg'),
    }

    return (
      icons[symbol.trim().toUpperCase()] ??
      require('@/assets/img/coin-icon.svg')
    )
  }
}
